// extracted by mini-css-extract-plugin
export var gif = "_mg-0";